<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-09-28 08:40:35
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 13:55:16
 * @Description: file content
 -->
<template>
  <div
    class="ActBaseBottom"
    :style="option&&option.style"
  >本次活动在法律允许范围内，最终解释权归{{ option || '上海原圈科技'}}所有</div>
</template>
<script>
export default {
  props: {
    // txt   不必填
    // style      不必填
    option: String
  },
  data() {
    return {};
  }
};
</script>
<style lang="css" scoped>
.ActBaseBottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  /* height: 20px; */
  line-height: 20px;
  background: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  font-size: 10px;
  text-align: center;
  z-index: 100;
}
</style>


